<template lang="en">
  <div id="top">
    <ul>
      <li v-for="(item,index) in routes" :key="index" :class="{ 'active-li': isActive(item.route) }">
        <router-link :to="item.route"><span>{{ item.name }}</span></router-link>
      </li>
      <li>
        <router-link to="/"><img src="@/assets/home/images/home.png" alt=""></router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  methods: {
    isActive(route) {
      // 先检查是否完全匹配
      if (this.$route.path === route) {
        return true;
      }
      // 再检查是否是前缀匹配，并且当前路径不是根路径
      if (route !== '/' && this.$route.path.startsWith(route)) {
        return true;
      }
      return false;
    }
  },
  computed: {
    routes() {
      return [{route:'/cases',name:'设计案例'}, {route:'/about',name:'关于友道'}, {route:'/reason',name:'选择理由'},{route:'/news',name:'新闻中心'},{route:'/join',name:'加入我们'}, {route:'/contact',name:'联系我们'}];
    }
  }
};
</script>
<style lang="scss">
  .active-li{
    background-color:#cb2229;
    a{
      span{
        color: white;
      }
    }
  }
</style>